import {SvgIconData} from '@shared_web/components/core/svg_icon';

import {TEXT_MAIN_COLOR} from '@mavismart_frontend/lib/constants';

export const icon_check: SvgIconData = {
  viewBox: '0 0 29 29',
  element: (
    <path
      d="M10.125 14.5L13.0417 17.4167L18.875 11.5833M27.625 14.5C27.625 21.7487 21.7487 27.625 14.5 27.625C7.25126 27.625 1.375 21.7487 1.375 14.5C1.375 7.25126 7.25126 1.375 14.5 1.375C21.7487 1.375 27.625 7.25126 27.625 14.5Z"
      stroke={TEXT_MAIN_COLOR}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
};
